import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../data.service';
import { GeneralService } from '../../../../general.service';
import {TranslateService} from '@ngx-translate/core';
import { SSL_OP_NETSCAPE_CHALLENGE_BUG } from 'constants';
import { Subscription } from 'rxjs';

declare var decimalInput: any;

@Component({
  selector: 'app-matrix',
  templateUrl: './matrix.html',
  styleUrls: ['./matrix.scss']
})

export class Matrix implements OnInit {

  public showDecimalInput = false;
  public isTouchDevice = false;
  public isInTask = false;
  public answers = [];
  public headers = [];
  public rows = [];
  public rowsArr = [];
  public comments = [];

  private loadAnswersSubscription : Subscription;
  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) { 
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }

    this.loadAnswersSubscription = this.dataSvc.getLoadMatrixLabelAnswersEvent().subscribe(()=>{
      this.loadAnswers();
    });
  }

  ngOnInit(): void {
    this.loadAnswers();
  }

  resetVariables(){
    this.answers = [];
    this.headers = [];
    this.rows = [];
    this.rowsArr = [];
  }

  loadAnswers() {   
    
    if(this.dataSvc.currentQuestion.Question.QuestionType !== 11) return;
    this.resetVariables();
    var tblMatrix = document.getElementById("tblMatrix");
    if(tblMatrix !== undefined && tblMatrix !== null){
      document.getElementById("tblMatrix").style.display = "none";
    }
    
    this.rows = [];
    var currentQuestion = this.dataSvc.currentQuestion;
    var headers = currentQuestion.Question.Question.Responses[0].Headings;
    var matrix = Object.keys(currentQuestion.Question.Question.Responses[0].Matrix).filter(k => k !== '$id');

    this.headers = headers;
    this.rows = matrix;

    setTimeout(() => {
      this.loadSavedAnswers();
      if(tblMatrix !== undefined && tblMatrix !== null){
        document.getElementById("tblMatrix").style.display = "block";
      }
    },1000);

  }

  loadSavedAnswers(){
    var savedAns = this.dataSvc.currentQuestion.Result.Selection;
    if(savedAns !== ""){
      this.answers = savedAns.split(",");
      for(var i = 0; i < this.answers.length; i++){
         var answer = this.answers[i].split(":");
         if(answer !== null && answer !== undefined){
           var elements = document.querySelectorAll("[data-rowindex='" + (parseInt(answer[0]) - 1) + "']");
           for(var e = 0; e < elements.length; e++){
            var element = (<HTMLInputElement>elements[e]);
            if(element !== null && element !== undefined){
              var header = parseInt(element.getAttribute("data-headerindex"));
              if((parseInt(answer[1]) - 1) === header){
                element.checked = true;
              }
            }
           }
         }
      }
    }
    else{
      var elemsEmpty = document.getElementsByClassName("matrixInput");
      for(var e1 = 0; e1 < elemsEmpty.length; e1++){
        var el = (<HTMLInputElement>elemsEmpty[e1]);
        if(el !== null && el !== undefined){         
          el.checked = false;
        }
    }
  }
  var savedComments = this.dataSvc.currentQuestion.Result.Comment;
  if(savedComments !== null && savedComments !== undefined && savedComments !== ""){
    this.comments = savedComments.split("|");
    for(var c = 0; c < this.comments.length; c++){
      var comment = this.comments[c].split(":");
      if(comment !== null && comment !== undefined){
        var rowId = comment[0].split(".")[1];
        var elems = document.querySelectorAll("[data-rowindex='" + (parseInt(rowId)-1) + "']");
          for(var e = 0; e < elems.length; e++){
            var ta = (<HTMLTextAreaElement>elems[e]);
            if(ta !== null && ta !== undefined){
              ta.value = comment[3];
            }
          }
        }
      }
    }
    else{
      this.comments = [];
      var taEmpty = document.getElementsByClassName("matrixTextbox");
      for(var x = 0; x < taEmpty.length; x++){
        var ta = (<HTMLTextAreaElement>taEmpty[x]);
        if(ta !== null && ta !== undefined){         
          ta.value = "";
        }
    }
    }
    
  }

  updateComments(event){
    var element = event.target;
    var row = parseInt((<HTMLInputElement>element).getAttribute("data-rowindex")) + 1;
    var text = (<HTMLInputElement>element).value;

    var key = "Q" + (this.dataSvc.currentExam.CurrentQuestion + 1) + "." + row;
    var comment = key + ": " + this.dataSvc.assessorName + ": " + new Date(Date.now()).toISOString().split('T')[0] + " : " + text.replace(":", "");
    var index = this.comments.findIndex(element => element.includes(key));
    if(index == -1)
    {
      this.comments.push(comment);
    }
    else{
      this.comments[this.comments.findIndex(element => element.includes(key))] = comment;
    }
    //console.log(this.comments);

    this.dataSvc.currentQuestion.Result.CommentsSimplified = this.comments.join("|");
    this.dataSvc.currentQuestion.Result.Comment = this.comments.join("|");
  }

  updateResponse(event){
    var element = event.target;
    var row = parseInt((<HTMLInputElement>element).getAttribute("data-rowindex"));
    var header = parseInt((<HTMLInputElement>element).getAttribute("data-headerindex"));

    var answer = (row + 1) +":" + (header + 1);
    var index = this.answers.findIndex(element => element.includes((row + 1) +":"))
    if(index == -1)
    {
      this.answers.push(answer);
    }
    else{
      this.answers[this.answers.findIndex(element => element.includes((row + 1) +":"))] = answer;
    }
    this.dataSvc.currentQuestion.Result.Selection = this.answers.join(",");
  } 
}
